// import clientService from '@/framework/client/clientService'
import router from '@/router'

const state = () => {
  return {
    phone: undefined,
    clients: [],
    selectedClient: undefined
  }
}

const getters = {
  getPhone: state => state.phone,
  getClients: state => state.clients,
  getSelectedClient: state => state.selectedClient
}

const mutations = {
  clearClient: (state) => {
    state.selectedClient = undefined
  },
  resetInformation: (state) => {
    state.phone = undefined
    state.selectedClient = undefined
    state.clients = []
  },
  resetCheckIn: (state) => {
    state.phone = undefined
    state.selectedClient = undefined
    state.clients = []
    router.push('/check/in')
  },
  updateClients: (state, clients) => {
    // hack for refreshing
    clients.forEach(c => {
      c.refresh = 0
    })
    state.clients = clients
    state.selectedClient = clients.length === 1 ? clients[0] : undefined
  },
  updatePhone: (state, phone) => {
    state.phone = phone
  },
  updateSelectedClient: (state, client) => {
    state.selectedClient = client
    router.push('client')
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
